/**
 * LinksPreviewCard
 * Affiche le maillage prévu entre les articles du dossier
 */
import React from 'react';
import { Link as LinkIcon } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';

export const LinksPreviewCard = ({ dossier, sitesById }) => {
  if (!dossier?.links || dossier.links.length === 0) return null;

  const siteName = (it) => it ? (sitesById[it.site_id]?.name || it.site_id || '?') : '?';
  
  const plannedDate = (it) => {
    if (!it) return null;
    if (it.scheduled_for) return new Date(it.scheduled_for);
    if (dossier.j0_date) {
      return new Date(new Date(dossier.j0_date).getTime() + (it.planned_publish_offset_days || 0) * 86400000);
    }
    return null;
  };
  
  const fmtDate = (d) => d ? d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' }) : '—';

  return (
    <Card className="border-cyan-500/30 bg-slate-900/40 mt-6">
      <CardHeader>
        <CardTitle className="text-sm text-cyan-300 flex items-center gap-2">
          <LinkIcon className="w-4 h-4" /> Maillage prévu ({dossier.links.length} lien(s))
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 text-xs">
          {dossier.links.map(l => {
            const from = dossier.items.find(i => i.id === l.from_item_id);
            const to = dossier.items.find(i => i.id === l.to_item_id);
            const fromDate = plannedDate(from);
            const toDate = plannedDate(to);

            return (
              <div key={l.id} className="p-3 rounded bg-slate-800/40 border border-slate-700/40" data-testid={`link-${l.id}`}>
                <div className="flex items-center gap-2 flex-wrap text-slate-200">
                  <span className="font-semibold text-cyan-300">{siteName(from)}</span>
                  <span className="text-[10px] text-slate-500">({fmtDate(fromDate)})</span>
                  <span className="text-cyan-400 px-1">→</span>
                  <span className="font-semibold text-cyan-300">{siteName(to)}</span>
                  <span className="text-[10px] text-slate-500">({fmtDate(toDate)})</span>
                </div>
                {l.anchor_text && (
                  <div className="mt-1 text-amber-300/80 italic">« {l.anchor_text} »</div>
                )}
                <div className="mt-1 text-[10px] text-slate-500 truncate" title={`${from ? (from.title || from.angle) : '?'}  →  ${to ? (to.title || to.angle) : '?'}`}>
                  {from ? (from.title || from.angle).slice(0, 50) : '?'} → {to ? (to.title || to.angle).slice(0, 50) : '?'}
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default LinksPreviewCard;
